module.exports = __webpack_public_path__ + "static/sport/bgi-form-h5.ba46352.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/bgi-form-h5.png
// module id = D4no
// module chunks = 0